var App = App || {};

App.ComponentHero = (function ($) {
    'use strict';

    function TabImages() {

        const tabsNav = $(".component-tabs .nav.nav-tabs").first();
        if (!tabsNav.length)
            return;

            if (typeof heroTabImages === "undefined" || !Array.isArray(heroTabImages))
        return;

        const tabs = tabsNav.find("[data-bs-toggle=\"tab\"]").toArray();
        if (tabs.length != heroTabImages.length)
            return;

        const desktop = $(".hero").find(".hero-image-desktop");
        const mobile = $(".hero").find(".hero-image-mobile");

        tabs.forEach(tab => {
            tab.addEventListener('shown.bs.tab', event => {
                const index = tabs.indexOf(tab);
                const image = heroTabImages[index];
                desktop.css(`background-image`, `url("${image.ImageLarge}")`);
                mobile.css(`background-image`, `url("${image.ImageMobile != "" ? image.ImageMobile : image.ImageLarge}")`);
            })
        });

    }

    function StickyCtaWaypoints() {

        const target = $(".hero").find(".hero-sticky");
        const elementShow = $(".hero .hero-ctas");
        const elementHide = $(".site-footer");

        if (target.length) {
            if (elementShow.length) {
                var waypointShow = new Waypoint({
                    element: elementShow,
                    handler: function (direction) {
                        StickyCtaShow(target, direction);
                    },
                    triggerOnce: false,
                    offset: 0
                })
            }

            if (elementHide.length) {
                var waypointHide = new Waypoint({
                    element: elementHide,
                    handler: function (direction) {
                        StickyCtaHide(target, direction);
                    },
                    triggerOnce: false,
                    offset: '100%'
                })
            }
        }


    }

    function StickyCtaShow(target, direction) {
        if (direction === "down") { target.slideDown(300); }
        else { target.slideUp(300); }
    }

    function StickyCtaHide(target, direction) {
        if (direction === "down") { target.slideUp(300); }
        else { target.slideDown(300); }
    }

    return {
        TabImages: TabImages,
        StickyCtaWaypoints: StickyCtaWaypoints
    };

})(jQuery);

$(function () {
    App.ComponentHero.TabImages();
    App.ComponentHero.StickyCtaWaypoints();
});